module.exports = __webpack_public_path__ + "static/media/tour_points_icon.8bbd5fd2.svg";